import { forwardRef } from "react";
import { Typography } from "antd";
import classNames from "classnames";
import type { ParagraphProps } from "antd/lib/typography/Paragraph";
import type { TextSize, TextWeight, TextType, TextLineHeight } from "../types";
import styles from "./styles.module.scss";

const { Paragraph } = Typography;

type Props = {
  textType?: TextType;
  weight?: TextWeight;
  size?: TextSize;
  lineHeight?: TextLineHeight;
} & ParagraphProps;

export const AppParagraph = forwardRef<HTMLElement, Props>(
  ({ className, textType, weight, size, lineHeight, ...props }, ref) => {
    return (
      <Paragraph
        ref={ref}
        className={classNames(
          [
            styles.paragraph,
            styles[`type-${textType}`],
            styles[`size-${size}`],
            styles[`weight-${weight}`],
            styles[`line-height-${lineHeight}`],
          ],
          className,
        )}
        {...props}
      />
    );
  },
);
